import { render, staticRenderFns } from "./chooseTag2.vue?vue&type=template&id=33a57bd5&scoped=true&"
import script from "./chooseTag2.vue?vue&type=script&lang=js&"
export * from "./chooseTag2.vue?vue&type=script&lang=js&"
import style0 from "./chooseTag2.vue?vue&type=style&index=0&id=33a57bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a57bd5",
  null
  
)

export default component.exports